import styled from "styled-components";

let titleBarHeight = 55;

export const OverviewBigScreenWrapper = styled.div`
    width: 100%;
    height: 100%;
    overflow-y: auto;
    color: #FFFFFF;
    letter-spacing: 2px;
    background-color: rgb(15, 53, 109);
`;

export const OverviewBigScreenInnerWrapper = styled.div`
    position: relative;
    width: 100%;
    height: 100%;
    min-height: 850px;
    color: #FFFFFF;
    letter-spacing: 2px; 
`;

export const ScreenBorderTop = styled.img`
    position: absolute;
    top: 10px;
    left: 0px;
    width: 100%;
    height: auto;
    z-index: 100;
`;

export const ScreenBorder= styled.img`
    position: absolute;
    top: calc(${titleBarHeight}px+5px);
    left: 2px;
    bottom: 1px;
    z-index: 80;
    background-color:rgb(15, 53, 109);
    width: 99%;
    height: calc(100% - ${titleBarHeight}px -5px);
`;

export const ScreenTitleBar = styled.div`
    position: absolute;
    z-index: 200;
    left: 0%;
    top: 0%;
    width: 100%;
    height: ${titleBarHeight}px;
    padding: 5px 20px 0px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-around;
`;

export const OverviewBigScreenContent = styled.div`
    display: grid;
    position: absolute;
    left:5px;
    right:2px;
    bottom:5px;
    top: calc(${titleBarHeight}px);
    width: calc(100%-10px);
    height: calc(100% - ${titleBarHeight}px-5px);
    padding: 20px ;
    overflow-x: hidden;
    overflow-y: hidden;
    grid-template-columns: 32.5% 32.5% 33%;
    grid-template-rows: 29% 29% 41% ;
    grid-gap: 10px;
    align-items: stretch;
    justify-items: stretch;
    box-sizing: border-box;
    z-index: 100;

`;


export const DeviceMapWrapper = styled.div`
    grid-column: 1 / 3;
    grid-row: 1 / 3;
    box-sizing: border-box;
    position: relative;
    z-index: 80;
    overflow-x: hidden;
    //box-shadow: inset 0 0 40px 10px rgba(15, 53, 109, 0.8);

    &::before {
     content: '';
     position: absolute;
     top: 0;
     left: 0;
     right: 0;
     bottom: 0;
     background: rgba(7, 67, 156, 0.3);
     z-index: 100; 
     pointer-events: none; 
    }
`;

export const DeviceOnlineStatisticsWrapper = styled.div`
    grid-column: 3 / 4;
    grid-row: 1 / 2;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
    margin-top: 10px;
`;

export const DeviceAlarmStatisticsWrapper = styled.div`
    grid-column: 1 / 2;
    grid-row: 3 / 4;
    box-sizing: border-box;
    z-index: 100;
`;

export const DeviceListWrapper = styled.div`
    grid-column: 2 / 3;
    grid-row: 3 / 4;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
`;


export const DeivceOnlineDurationWrapper = styled.div`
    
    grid-column: 3 / 4;
    grid-row: 2 / 3;
    box-sizing: border-box;
    overflow: hidden;
    z-index: 100;
    position: relative;
`;

export const DeviceAnalyseWrapper = styled.div`
    grid-column: 3 / 4;
    grid-row: 3 / 4;
    box-sizing: border-box;
    overflow: hidden;
`;

